import React,{useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {currentRouteSet} from '../../../actions/actions';
import {pathSpliter} from '../../../lib/functions';
import MCTPurchaseInvoice from './load_machine_cycle_time_invoice';
import { makeStyles } from '@material-ui/core/styles';
import {API_URL} from '../../../config.json';
import axios from 'axios';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';

const MachineCycleTimeInvoiceQuick = ({location,currentRouteSet,authInfo})=>{
  const classes = useStyles();
    let [invoices,invoicesSet] = useState([]);
    let [selectedInvoice,selectedInvoiceSet] = useState(null);
    let [machine_cycle_id,machine_cycle_idSet] = useState(null);
    let [institution,institutionSet] = useState(null);

    useEffect(()=>{
        currentRouteSet(pathSpliter(location.pathname,1));
        getPurchaseInvoices();
        getInstitution();
    },[]);

    

    let getPurchaseInvoices = async ()=>{
        await axios.get(`${API_URL}/api/get-machine-cycle-time-invoices`,{headers:{'auth-token':authInfo.token}}).then(res=>{
            console.log(res.data,'invices set');
          invoicesSet(res.data);
        })
    }

    let getInstitution = async ()=>{
        await  axios.get(`${API_URL}/api/get-institution`,{headers:{'auth-token':authInfo.token}}).then(res=>{
            institutionSet(res.data)
     })
    }

      return(
          <>
            <Grid container>
  
  <Grid item xs={12} sm={12}>
        <Grid xs={12} sm={12} style={{width:'250px',marginBottom:'20px',margin: '0px auto'}}>
        <Autocomplete 
          

           openOnFocus={true}
           autoHighlight={true}
           style={{width:'100%',height:'20px'}}
           options={invoices}
           value={selectedInvoice}
           classes={{
            option: classes.option,
          }}
           size="small"
           getOptionLabel={(option) => option.prod_name}
           onChange={(e,invoice)=>{
            selectedInvoiceSet(invoice)
              if(invoice != null){
                  machine_cycle_idSet(invoice.machine_cycle_prod_id )
              }
           }}
           renderInput={(params) => <TextField 
   
       {...params} 
       label="Select Save Machine Cycle Time" 
       variant="outlined"
       
       />} />


</Grid>
  </Grid>
  </Grid>
              <MCTPurchaseInvoice purchaseId={machine_cycle_id} institution={institution}/>
          </>
      )
}
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  inputField:{
    width:'100%',
    marginTop:'5px'
  },
  plusLinkDiv:{
    position:'relative'  
  },
  plusLink:{
    margin: 0,
    padding: 0,
    marginTop: '-21px',
    fontSize: '29px',
    height: '21px',
    textAlign: 'right',
    position: 'absolute',
    right: 0,
    color: '#3e8d54'
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));
  const mapStateToPops = (state)=>{
    return {
      currentRoute:state.currentRouteReducer,
      authInfo:state.authInfoReducer
    }
}

export default connect(mapStateToPops,{currentRouteSet})(MachineCycleTimeInvoiceQuick);